import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import ViewPreviousVersionButon from '../../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Message, Panel } from 'rsuite'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PersonalBasicInfo from '../../../widgets/personalBasicInfo/PersonalBasicInfo'
import CompanyBasicInfo from '../../../widgets/companyBasicInfo/CompanyBasicInfo'
import AddressWork from '../../../widgets/address/addressWork/AddressWork'
import AddressCard from '../../../widgets/address/addressCard/AddressCard'
import FormAddress from '../../../widgets/address/formAddress/FormAddress'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import AddressDeliveryDocument from '../../../widgets/address/addressDeliveryDocument/AddressDeliveryDocument'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getSchemaProposalGranteeBasicInfo } from '../../../redux/actions/proposalGranteeBasicInfo'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import CurrentAddress from '../../../widgets/address/currentAddress/CurrentAddress'
import pathname from '../../../constants/pathname'
import CustomAlertMessageInfo from '../../../widgets/CustomAlertMessageInfo'
import CustomNote from '../../../widgets/CustomNote'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import '../styles.less'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function ProposalGranteeBasicInfo() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  const [isViewPrevious, setIsViewPrevious] = useState(false)
  const [addressWork, setAddressWork] = useState()
  const [addressCard, setAddressCard] = useState()
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()

  const previousPanelRef = useRef(null)
  const projectId = sessionStorage.getItem('projectId')
  const type = 'grantee'

  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.responsibleManBasicInfo}`,
    pathNameForward: `${pathname.proposal.expectedResult}`,
  }

  useEffect(() => {
    if (projectId) handleGetSchema()
    else setError({ statusCode: 404, errorMessage: ERR_MSG_404_PROJECT_ID })
  }, [])

  useEffect(() => {
    if (isViewPrevious && schemaPrevious) {
      previousPanelRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [isViewPrevious, schemaPrevious])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaProposalGranteeBasicInfo(projectId)

      if (_schema?.forms?.currentAddress) {
        setAddressWork(initAddress(_schema?.forms?.currentAddress))
      } else {
        setAddressWork(initAddress(_schema?.forms?.companyAddress))
      }
      setAddressCard(initAddress(_schema?.forms?.idCardAddress))

      setSchema(_schema)
      setIsEditWidget({
        persomal: _schema.forms?.persomal?.id ? false : true,
        company: _schema.forms?.company?.id ? false : true,
        companyAddress: _schema.forms?.companyAddress?.id ? false : true,
        idCardAddress: _schema.forms?.idCardAddress?.id ? false : true,
        documentAddress: _schema.forms?.documentAddress?.id ? false : true,
        officeLocation: _schema.forms?.officeLocation?.id ? false : true,
        formAddress: _schema.forms?.formAddress?.id ? false : true,
        currentAddress: _schema.forms?.currentAddress?.id ? false : true,
        organizationAddress: _schema.forms?.organizationAddress?.id ? false : true,
      })

      setShowEditAll(!_schema.forms?.persomal?.disabled && !_schema.forms?.company?.disabled)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      const _schema = await getSchemaProposalGranteeBasicInfo(id)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {
      console.error(e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const initAddress = (address) => ({
    buildingName: address?.buildingName?.value,
    roomNumber: address?.roomNumber?.value,
    houseNumber: address?.houseNumber?.value,
    villageNumber: address?.villageNumber?.value,
    lane: address?.lane?.value,
    villageName: address?.villageName?.value,
    road: address?.road?.value,
    location: address?.location?.value,
    telephone: address?.telephone?.value,
    mobile: address?.mobile?.value,
    fax: address?.fax?.value,
    email: address?.email?.value,
  })

  // 🚩 ก้อนสำหรับ Render เนื้อหา (ใช้ร่วมกันทั้งปัจจุบันและเวอร์ชันเก่า)
  const renderVersion = (data, isCurrent = true) => (
    <div className={isCurrent ? 'top' : 'bottom'}>
      {data?.forms?.granteeInfo && (
        <>
          <Panel header={data.header} shaded>
            <WarningMessage
              style={{ marginTop: -10 }}
              message={
                data?.forms?.company?.feedbackBySubject || data?.forms?.persomal?.feedbackBySubject
              }
            />
            <CustomAlertMessageInfo contents={data.forms.granteeInfo.description} />
            {data.forms.granteeInfo.descriptionNote && (
              <div style={{ marginTop: 10 }}>
                <CustomNote key="ct1" data={data.forms.granteeInfo.descriptionNote} />
              </div>
            )}
            <Message
                showIcon
                type="warning"
                description={
                  'กรณีทำสัญญา/ข้อตกลง แบบอิเล็กทรอนิกส์: สำหรับใช้ในการลงนาม กรุณาระบุอีเมล และเบอร์โทรศัพท์ ที่มีการลงทะเบียนการเข้าใช้ Web Portal และ ยืนยันตัวตน (KYC) ให้เรียบร้อย'
                }
              />
          </Panel>
          <br />
        </>
      )}

      {/* ข้อมูลเบื้องต้นนิติบุคล */}
      {data?.forms?.company && (
        <>
          <CompanyBasicInfo
            showCommandButton={isCurrent && !data.forms.company.disabled}
            schema={data.forms.company}
            isEdit={isCurrent ? isEditWidget.company && !data.forms.company.disabled : false}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('company', _isEdit, setIsEditWidget)}
            type={type}
            offerFundedInfoSchema={schema.forms.offerFundedInfo}
          />
          <br />
        </>
      )}

      {/* ข้อมูลที่อยู่ตาม form 1-8 */}
      {data?.forms?.formAddress && (
        <>
          <FormAddress
            showCommandButton={isCurrent && !data.forms.formAddress.disabled}
            schema={data?.forms?.formAddress}
            isEdit={
              isCurrent ? isEditWidget.formAddress && !data.forms.formAddress.disabled : false
            }
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('formAddress', _isEdit, setIsEditWidget)
            }
            type="form"
          />
          <br />
        </>
      )}

      {/* ที่อยู่ที่ตั้งองค์กร (นิติบุคล)*/}
      {data?.forms?.organizationAddress && (
        <>
          <AddressWork
            showCommandButton={isCurrent && !data.forms.organizationAddress.disabled}
            schema={data.forms.organizationAddress}
            isEdit={
              isCurrent
                ? isEditWidget.organizationAddress && !data.forms.organizationAddress.disabled
                : false
            }
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('organizationAddress', _isEdit, setIsEditWidget)
            }
            handleOnSubmit={isCurrent ? (val) => setAddressWork(val) : undefined}
            type={type}
            isCompany={true}
          />
          <br />
        </>
      )}

      {/* ข้อมูลเบื้องต้นบุคคลธรรมดา */}
      {data?.forms?.persomal && (
        <>
          <PersonalBasicInfo
            showCommandButton={isCurrent && !data.forms.persomal.disabled}
            honorificOptions={data.forms.honorificOptions}
            schema={data.forms.persomal}
            isEdit={isCurrent ? isEditWidget.persomal && !data.forms.persomal.disabled : false}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('persomal', _isEdit, setIsEditWidget)}
            type={type}
            offerFundedInfoSchema={schema?.forms?.company ? null : schema.forms.offerFundedInfo}
          />
          <br />
        </>
      )}

      {/* ที่อยู่ปัจจุบัน */}
      {data?.forms?.currentAddress && (
        <>
          <CurrentAddress
            showCommandButton={isCurrent && !data.forms.currentAddress.disabled}
            schema={data.forms.currentAddress}
            isEdit={
              isCurrent ? isEditWidget.currentAddress && !data.forms.currentAddress.disabled : false
            }
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('currentAddress', _isEdit, setIsEditWidget)
            }
            handleOnSubmit={isCurrent ? (val) => setAddressWork(val) : undefined}
            type={type}
          />
          <br />
        </>
      )}

      {/* ที่อยู่สถานที่ทำงาน (นิติบุคล)*/}
      {data?.forms?.companyAddress && (
        <>
          <AddressWork
            showCommandButton={isCurrent && !data.forms.companyAddress.disabled}
            schema={data.forms.companyAddress}
            isEdit={
              isCurrent ? isEditWidget.companyAddress && !data.forms.companyAddress.disabled : false
            }
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('companyAddress', _isEdit, setIsEditWidget)
            }
            handleOnSubmit={isCurrent ? (val) => setAddressWork(val) : undefined}
            type={type}
          />
          <br />
        </>
      )}

      {/* ที่อยู่ตามบัตรประชาชน */}
      {data?.forms?.idCardAddress && (
        <>
          <AddressCard
            showCommandButton={isCurrent && !data.forms.idCardAddress.disabled}
            schema={data.forms.idCardAddress}
            isEdit={
              isCurrent ? isEditWidget.idCardAddress && !data.forms.idCardAddress.disabled : false
            }
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('idCardAddress', _isEdit, setIsEditWidget)
            }
            handleOnSubmit={isCurrent ? (val) => setAddressCard(val) : undefined}
            addressWork={addressWork}
            type={type}
          />
          <br />
        </>
      )}

      {/* ที่อยู่ที่จัดส่งเอกสาร */}
      {data?.forms?.documentAddress && (
        <>
          <AddressDeliveryDocument
            showCommandButton={isCurrent && !data.forms.documentAddress.disabled}
            schema={data.forms.documentAddress}
            isEdit={
              isCurrent
                ? isEditWidget.documentAddress && !data.forms.documentAddress.disabled
                : false
            }
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('documentAddress', _isEdit, setIsEditWidget)
            }
            addressWork={addressWork}
            addressCard={addressCard}
            type={type}
          />
          <br />
        </>
      )}

      {/* ที่อยู่สถานที่ทำงาน (บุคคลธรรมดา)*/}
      {data?.forms?.officeLocation && (
        <>
          <AddressWork
            showCommandButton={isCurrent && !data.forms.officeLocation.disabled}
            schema={data.forms.officeLocation}
            isEdit={
              isCurrent ? isEditWidget.officeLocation && !data.forms.officeLocation.disabled : false
            }
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('officeLocation', _isEdit, setIsEditWidget)
            }
            type={type}
          />
          <br />
        </>
      )}
    </div>
  )

  if (error)
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )

  if (!schema || isLoading)
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ViewPreviousVersionButon
        handleGetSchemaPrevious={handleGetSchemaPrevious}
        isViewPrevious={isViewPrevious}
        masterSubjectId={'1-1030,5-5015'}
      />

      {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          routing={buttonRoute}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          editWidget={isEditWidget}
          forms={schema?.forms}
        />
      )}

      <div className="wrapper proposal-grantee-page" style={{ display: 'block', width: '100%' }}>
        <div style={{ width: '100%', minWidth: 0 }}>
          {isViewPrevious ? (
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              header={'version ปัจจุบัน'}
              style={{ maxHeight: '700px', overflowY: 'auto', width: '100%' }}
            >
              <div style={{ padding: 0, width: '100%' }}>{renderVersion(schema, true)}</div>
            </Panel>
          ) : (
            renderVersion(schema, true)
          )}
        </div>

        {isViewPrevious && schemaPrevious && (
          <div
            ref={previousPanelRef}
            className="proposal-grantee-previous"
            style={{ width: '100%', minWidth: 0, marginTop: '16px' }}
          >
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              header={'version ก่อนหน้า'}
              style={{
                maxHeight: '700px',
                overflowY: 'auto',
                width: '100%',
                backgroundColor: '#e4e4ed',
              }}
            >
              <div
                className="bottom proposal-grantee-previous-body"
                style={{ padding: '0', width: '100%' }}
              >
                {renderVersion(schemaPrevious, false)}
              </div>
            </Panel>
            <br />
            <br />
          </div>
        )}
      </div>
    </SidebarProposal>
  )
}
